if standalone
    #build-navigation.secondary-row
        .container
            .row
                .col-sm-4
                    if standalone
                        h4 Target & Publish Settings
